export default "__VITE_ASSET__Dif1xrJP__"